import { render, staticRenderFns } from "./CustomReportPage8.vue?vue&type=template&id=c96c0ec8"
import script from "./CustomReportPage8.vue?vue&type=script&lang=js"
export * from "./CustomReportPage8.vue?vue&type=script&lang=js"
import style0 from "./CustomReportPage8.vue?vue&type=style&index=0&id=c96c0ec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports